import { constants } from '../utils/constants'
import helpers from './helpers'
import helpersGlobal from '../utils/helpers'
import messages from '../utils/messages'
/*const local = {
  METADATA_ADDRESS: '0xcBB2912666c7e8023B7ec78B6842702eB26336aC',
  KEYS_MANAGER_ADDRESS: '0x2b1dbc7390a65dc40f7d64d67ea11b4d627dd1bf',
  POA_ADDRESS: '0x83451c8bc04d4ee9745ccc58edfab88037bc48cc',
  MOC: '0xCf260eA317555637C55F70e55dbA8D5ad8414Cb0'
}*/

/*const abc = {
  METADATA_ADDRESS: '0x8e1ED1bBa91D8d7C285BD6f807a7b885ADA4472d',
  KEYS_MANAGER_ADDRESS: '0x08bD3D409c036636Fd618929196a12709d148afE',
  POA_ADDRESS: '0x83451c8bc04d4ee9745ccc58edfab88037bc48cc',
  MOC: '0x775b047021b35d5eeb6057e596f7c47e31176999'
}*/

export default web3Config => {
  const branch = constants.NETWORKS[web3Config.netId].BRANCH
  return new Promise((resolve, reject) => {
    fetch(helpers.addressesURL(branch))
      .then(response => {
        response.json().then(json => {
          const network = constants.NETWORKS[web3Config.netId] || {}
          const addresses = Object.assign({}, json)
          if (network.CONSENSUS_ADDRESS) {
            addresses.CONSENSUS_ADDRESS = network.CONSENSUS_ADDRESS
          }
          resolve({ addresses, web3Config })
        })
      })
      .catch(function(err) {
        let addr = helpers.addressesURL(branch)
        let msg = `
                Something went wrong!<br/><br/>
                ${messages.wrongRepo(addr)}
            `
        helpersGlobal.generateAlert('error', 'Error!', msg)
        reject(err)
      })
  })
}
